import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { errorMsg, homeUrl, success } from '../utils/common_utils';
import { MSG_ERROR_PROGRESS_UI } from '../common_components/common_ui_components';
import { NavbarTop } from '../common_components/navbar_top';
import {CompanyTagUI, CompanyTagRowsUI, CompanyTagTealUI} from './imp_companies_list_ui';
import { ConnectAndBook } from '../common_components/connect_and_book';

// Purple + teal badge palette for company descriptions
/**
 'bg-purple-100 text-purple-800',
    'bg-purple-200 text-purple-900',
    'bg-teal-200 text-teal-900',
 */
const colorPalette = [
    'bg-teal-100 text-gray-800'
  ];

function DSAInterviewSetsTable() {
  const { companyCode } = useParams(); // expects route like /dsa/:companyCode? (companyCode optional)

  const [sets, setSets] = useState([]);
  const [impCompanies, setImpCompanies] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showProgress, setShowProgress] = useState(false);
  const [companyName, setCompanyName]=useState(companyCode)

  // Build the correct endpoint
  const endpoint = companyCode
    ? `${homeUrl()}dsaApi/company/${companyCode}`
    : `${homeUrl()}dsaApi/all`;

  useEffect(() => {
    async function fetchSets() {
      setShowProgress(true);
      try {
        const res = await fetch(endpoint);
        const data = await res.json();

        if (success(data.status)) {
          setSets(data.sets ?? []);
          setCompanyName(data.companyName)
          setImpCompanies(data.impCompanies);
         // setMessage('Interview sets loaded successfully.');
        } else {
          setError(data.message || 'Failed to load interview sets.');
        }
      } catch (e) {
        console.log('Error fetching interview sets', e);
        setError(errorMsg());
      } finally {
        setShowProgress(false);
      }
    }
    fetchSets();
    // Reload if company code changes
  }, []);

  return (
    <div className=" flex flex-col   mx-auto">
        <NavbarTop />
        <div className='mt-20'></div>
        <div className='text-4xl flex flex-col leading-10
         text-center items-center justify-center my-8'>
           <h1 className='mb-2'>
            {companyName &&
           <span className='mt-4 text-teal-600  font-bold font-mono'>
            {companyName} </span>
}
             DS & Algo AI Mock Interview Sets 
           
           
           </h1>
           
           { impCompanies && 
            <div className='mt-4'>
              <CompanyTagRowsUI companies={impCompanies} />
              </div>
           }
           {
            <div className='text-gray-500 text-sm italic'> 
            <br />
             Each interview set has all questions that were 
             asked in the same interview round <br />
            Counter questions/follow ups asked by AI interviewer
             are picked from multiple different interview rounds.
            </div>
           }
        </div>
        <br /> 
      {/* error success message and progressbar row */}
      <MSG_ERROR_PROGRESS_UI
        message={message}
        error={error}
        showProgress={showProgress}
      />

      <div className="w-4/5 mx-auto overflow-x-auto mt-4">
        <table className="w-full text-left border-collapse shadow-lg">
          <thead>
            <tr className="border-b ">
              <th className="py-3 px-4">ID</th>
              <th className="py-3 px-4">Heading</th>
              <th className="py-3 px-4 text-center">Companies</th>
              <th className="py-3 px-4 text-center">Asked In</th>
            </tr>
          </thead>
          <tbody>
            {sets.map((set) => (
              <tr
                key={set.interviewSetId}
                className="odd:bg-white even:bg-gray-50 "
              >
                <td className="py-3 px-4 font-mono text-sm">
                  {set.interviewSetId}
                </td>
                <td className="py-3 px-8  max-w-xs">
                <a
                    href={`/question/${set.interviewSetId}`}
                    target='_blank'
                    className="text-gray-700 hover:underline"
                  >
                    {set.heading}
                  </a>
                </td>
                <td className="py-3 px-4">
                <div className="flex flex-wrap text-center 
                items-center justify-center gap-2">
                    {set.companies.map((c, idx) => (
                     <CompanyTagUI company={c} />
                    ))}
                  </div>
                </td>
                <td className="py-3 px-4">
                  <div className="flex flex-col gap-1 text-center">
                    {set.companyDescriptions.map((desc, idx) => (
                      <span
                        key={idx}
                        className={`px-2 py-1 rounded text-sm whitespace-pre-line text-gray-800`} // ${colorPalette[idx % colorPalette.length]}
                      >
                        {desc}
                      </span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
      </div>
      <br />
      <ConnectAndBook />
      { sets && sets.length>0 && 
          <div className='min-h-16 w-full bg-gray-500'>
            
          </div>
        }
    </div>
  );
}


function DSASetsLinkHomePage(){ 
    return (
        <a className='flex flex-col m-4 px-8 py-4
         text-white bg-teal-600 text-xl font-semibold
         text-center font-mono  rounded-md z-0 shadow-lg
         cursor-pointer leading-10
         hover:text-white hover:bg-teal-700'
         
         href="/dsa" >
         <span className='text-2xl font-bold'>DS & Algo </span>
         AI Mock Interview Sets
         <button className='bg-white mt-4 text-gray-600
         rounded-full  hover:text-gray-800' 
         >
            View All</button>
        </a>
    )
  //  bg-purple-600 hover:bg-purple-700
}

export {DSAInterviewSetsTable, DSASetsLinkHomePage}